import React from 'react';
import PropTypes from 'prop-types';
import Cell from '~/glm/components/shared/guest-import/guest-import-spreadsheet/cell';
import GuestCandidateModel from '~/glm/models/shared/guest-import/guest-candidate-model';
import styles from './row.scss';

const Row = ({ rowId, guest, disabled, handlePaste, handleTrackValidationError }) => (
  <div className={styles.row}>
    {GuestCandidateModel.TABLE_COLUMN_MAPPING.map((field, i) => (
      <Cell
        disabled={disabled}
        key={i}
        fieldName={field.apiName}
        guest={guest}
        rowId={rowId}
        colId={i}
        handlePaste={handlePaste}
        handleTrackValidationError={handleTrackValidationError}
      />
    ))}
  </div>
);

Row.propTypes = {
  rowId: PropTypes.number.isRequired,
  guest: PropTypes.instanceOf(GuestCandidateModel).isRequired,
  disabled: PropTypes.bool,
  handlePaste: PropTypes.func,
  handleTrackValidationError: PropTypes.func,
};

export default Row;
